import React, {Proptypes} from 'react';
import DashboardFixedHeader from './fixed_header';
import ResponsiveDashboardHeader from './responsive_header.jsx';
const MediaQuery = require('react-responsive');
import './dashboard_header.less';
import profileActions from '../profile/profile_actions';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import CONSTANTS from '../common_constants';
import LogoutPopUp from '../components/logoutPopUp/logout_pop_up';
import authActions from '../auth/auth_actions';
import cookies from '../util/cookie';

class DashBoardHeader extends React.Component{
  constructor(props) {
    super(props);
  }
  componentDidMount(){
    this.getAllNotifications();
    setInterval(this.getAllNotifications, 30000);   //every 30seconds the notification will be called
  }

  logout = ()=>{
   this.props.authActions.logout().always(() => {
        cookies.delete('_sd');
        document.location.href = '/';
    });
  }

  getAllNotifications = () =>{
    let paramObj = {
      type : 0 ,
      offset : 0,
      count : 50
    }
    this.props.profileActions.getAllNotifications(paramObj).then((data)=>{
    },(errorRes)=>{
      if(errorRes.error === CONSTANTS.sessionInvalid){
            this.setState({ajaxInProgress: false})
            this.props.authActions.sessionValid(false);
            cookies.delete('_sd');
            return ;
    }
    })
  }
  render(){
    const {props, state} = this;
    const {userData} = props.authState;
    let sessionValid = true ;
    let logout;
    (props.logout) ? (logout = props.logout) : (logout = this.logout);
    if("sessionValid" in props.authState.userData)
        sessionValid = props.authState.userData.sessionValid;
    return(
      <header className="dashboard-header">
          <LogoutPopUp isOpen={!sessionValid}></LogoutPopUp>
        <MediaQuery query='(min-width: 768px)'>
          <div className="wrapper">
            <DashboardFixedHeader notifications ={this.props.profile.notifications.notifications}user={this.props.user} location={this.props.location}/>
          </div>
        </MediaQuery>
        <MediaQuery query='(max-width: 767px)'>
          <ResponsiveDashboardHeader user={this.props.user} logout={logout} location={this.props.location}/>
        </MediaQuery>
      </header>
    )
  }
}

DashBoardHeader = connect((state) => {
    return {profile: state.app.profile,authState: state.app.auth}
}, (dispatch) => {
    return {
        profileActions: bindActionCreators(profileActions, dispatch),
        authActions: bindActionCreators(authActions, dispatch)
    }
})(DashBoardHeader);

export default DashBoardHeader;



// WEBPACK FOOTER //
// app/header_dashboard/dashboard_header.jsx